import { Suspense } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import GoogleAnalytics from "./components/googleanalytics";
import Loader from "./components/loader";
import { TranslationProvider } from "./context/TranslationContext";
import "./i18n";
import store from "./redux/Store";
import Router from "./router";

let persistor = persistStore(store);

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <TranslationProvider>
          <Suspense fallback={<Loader loading={true} />}>
            <ToastContainer />
            <BrowserRouter>
              <Router />
            </BrowserRouter>
            <GoogleAnalytics />
          </Suspense>
        </TranslationProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
